import ActionCable from 'actioncable'

/**
 * Transform HTTP URL to Websocket URL
 * @param {string} url HTTPS URL
 * @returns {string} Websocket URL
 * @example
 * extractURLwithoutHTTP('https://dummyhost.com/')
 * return 'ws://dummyhost.com/cable'
 */
const extractURLWithoutHTTP = (url) => {
  const baseName = url.split('//')[1]
  return `wss://${baseName}/cable`
}

const URL = extractURLWithoutHTTP(process.env.REACT_APP_BASE_URL)
const consumer = ActionCable.createConsumer(URL)

const baseURLCable = URL

export { baseURLCable }

export default consumer
